<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item>
      <excelExport
            ref="export"
            :tableName="tableName"
            :values="values"
            :titles="titles"
            @startExport="startExport"
          >
            <el-radio v-model="extype" :label="1"
              >当前页数据，{{ DataList.length }}条</el-radio
            >
            <el-radio v-model="extype" :label="2"
              >导出当前条件的全部数据</el-radio
            >
          </excelExport>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
    </auto-table>

  </div>
</template>

<script>
import excelExport from "@/components/excel/excelExport.vue";
export default {
    components:{
excelExport
    },
  data() {
    return {
      DataList: [],
      Option: [
        { name: "到店人", value: "nick_name" },
        { name: "电话", value: "mobile" }
      ],
      Total: 0,
      status: 0,
      mechanism_id: "",
      extype:1,
      tableName: "门店导入学员",
      values: [
        "nick_name",
        "mobile"
      ],
      titles: ["昵称", "电话"],
    };
  },

  mounted() {
    this.mechanism_id = this.$route.query.mecID;
  },

  methods: {
   // 导出表格
    startExport() {
      if (this.extype === 1) {
        let DataList = this.DataList;
        this.$refs.export.importExcel(DataList);
      } else {
        this.exportInfo();
      }
    },
    exportInfo() {
      let params = {
         bind_invite: "mec#" + this.mechanism_id,
      };
     
      this.$axios({
        url: "/user/userInfo/query",
        params,
      }).then((res) => {
        let DataList = res.data.data;
        DataList.forEach((item) => {
          item.sex = item.sex === 1 ? "男" : "女";
        });
        this.$refs.export.importExcel(DataList);
      });
    },
    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/userInfo/queryManagerListPage",
        params: {
          bind_invite: "mec#" + this.mechanism_id,
          currentPage: page,
          pageSize: 10,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>